import { useMutation, useQuery } from "@apollo/client";
import {
  ADD_INCIDENT_COMMENT_MUTATION,
  ASSIGN_INCIDENT_MUTATION,
  GET_INCIDENT_DETAIL,
  UPDATE_HELP_REQUEST_STATUS_MUTATION,
  UPDATE_INCIDENT_PRIORITY_MUTATION,
} from "../graphQl/SupportAPI";

// Chaque action ajoute une entrée d'audit côté API : on recharge le détail (incident + commentaires + events)
// et la liste / les KPI.
const REFETCH_AFTER_ACTION = {
  refetchQueries: ["IncidentDetail", "ListIncidents", "IncidentKpi"],
  awaitRefetchQueries: true,
};

export const useIncidentDetail = (incidentId) => {
  const { data, loading, error, refetch } = useQuery(GET_INCIDENT_DETAIL, {
    variables: { incidentId },
    skip: !incidentId,
    fetchPolicy: "cache-and-network",
  });

  const [assignMutation, { loading: isAssigning }] = useMutation(ASSIGN_INCIDENT_MUTATION, REFETCH_AFTER_ACTION);
  const [priorityMutation, { loading: isUpdatingPriority }] = useMutation(UPDATE_INCIDENT_PRIORITY_MUTATION, REFETCH_AFTER_ACTION);
  const [statusMutation, { loading: isUpdatingStatus }] = useMutation(UPDATE_HELP_REQUEST_STATUS_MUTATION, REFETCH_AFTER_ACTION);
  const [commentMutation, { loading: isCommenting }] = useMutation(ADD_INCIDENT_COMMENT_MUTATION, REFETCH_AFTER_ACTION);

  const incident = data?.QR_GET_INCIDENT?.data?.incident || null;
  const request = data?.QR_GET_INCIDENT?.data?.request || null;

  const assign = async (assigneeId) => {
    const res = await assignMutation({ variables: { incidentId, assigneeUpdateInput: { assigneeId } } });
    return res.data?.MT_ASSIGN_INCIDENT?.data;
  };

  const changePriority = async (priority) => {
    const res = await priorityMutation({ variables: { incidentId, priorityUpdateInput: { priority } } });
    return res.data?.MT_UPDATE_INCIDENT_PRIORITY?.data;
  };

  const changeStatus = async (status, resolutionComment) => {
    const res = await statusMutation({
      variables: {
        helpRequestId: incident?.requestId || request?.id,
        statusUpdateInput: { status, resolutionComment: resolutionComment || undefined },
      },
    });
    return res.data?.MT_UPDATE_HELP_REQUEST_STATUS?.data;
  };

  const addComment = async (content, attachments) => {
    const res = await commentMutation({
      variables: { incidentId, commentInput: { content, attachments: attachments?.length ? attachments : undefined } },
    });
    return res.data?.MT_ADD_INCIDENT_COMMENT?.data;
  };

  return {
    incident,
    request,
    comments: data?.QR_LIST_INCIDENT_COMMENT?.data?.content || [],
    events: data?.QR_LIST_INCIDENT_EVENT?.data?.content || [],
    loading,
    error,
    refetch,
    assign,
    changePriority,
    changeStatus,
    addComment,
    isMutating: isAssigning || isUpdatingPriority || isUpdatingStatus || isCommenting,
    isCommenting,
  };
};
